/**
 * User-visible copy for AppSync invoke + subscription flows (QMA, comps agent, etc.).
 * Thrown `Error.message` values surface in snackbars, the notification inbox, and Property Detail cards.
 * Log technical details separately in code paths that call `logProcessTracking` or server-side monitoring.
 *
 * @module store/subscriptionCore/subscriptionUserMessages
 */

/** Subscription sent `status: "error"` after a successful invoke. */
export const SUBSCRIPTION_REPORTED_ERROR =
  "This step couldn't finish just now. Please wait a moment and try again.";

/** Invoke returned a non-success HTTP-style statusCode. */
export const INVOKE_NOT_ACCEPTED = "We couldn't start this for you. Please try again.";

/** Invoke succeeded but response had no correlation id for the subscription. */
export const MISSING_CORRELATION_ID = "We couldn't connect to finish this. Please try again.";

/** Terminal subscription payload was neither processing, error, nor a successful done. */
export const UNEXPECTED_TERMINAL_EVENT = "Something didn't complete as expected. Please try again.";
